var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLucideLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 54,
    viewBox: "0 0 59 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9194 1.43985C43.8885 0.357126 45.5518 0.264984 46.6345 1.23405C53.6277 7.4931 58.0349 16.5973 58.0349 26.7273C58.0349 39.805 47.4335 50.4064 34.3559 50.4064C21.2783 50.4064 10.6768 39.805 10.6768 26.7273C10.6768 19.462 16.5665 13.5723 23.8319 13.5723C31.0971 13.5723 36.9869 19.462 36.9869 26.7273C36.9869 28.1804 35.8089 29.3583 34.3559 29.3583C32.9028 29.3583 31.7249 28.1804 31.7249 26.7273C31.7249 22.3682 28.191 18.8343 23.8319 18.8343C19.4727 18.8343 15.9389 22.3681 15.9389 26.7273C15.9389 36.8988 24.1844 45.1443 34.3559 45.1443C44.5274 45.1443 52.7729 36.8988 52.7729 26.7273C52.7729 18.1562 49.0503 10.458 43.1252 5.15496C42.0425 4.18589 41.9504 2.52258 42.9194 1.43985Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.152832 26.7271C0.152832 13.6496 10.7543 3.0481 23.8319 3.0481C36.9095 3.0481 47.5109 13.6496 47.5109 26.7271C47.5109 33.9923 41.6211 39.8821 34.3559 39.8821C27.0907 39.8821 21.2009 33.9923 21.2009 26.7271C21.2009 25.2741 22.3788 24.0961 23.8319 24.0961C25.2849 24.0961 26.4629 25.2741 26.4629 26.7271C26.4629 31.0862 29.9968 34.6201 34.3559 34.6201C38.715 34.6201 42.2489 31.0862 42.2489 26.7271C42.2489 16.5557 34.0034 8.3101 23.8319 8.3101C13.6604 8.3101 5.41484 16.5557 5.41484 26.7271C5.41484 35.3707 9.20073 43.1268 15.2134 48.4336C16.3028 49.3951 16.4065 51.0577 15.4449 52.1472C14.4834 53.2366 12.8208 53.3403 11.7314 52.3787C4.63498 46.1154 0.152832 36.9431 0.152832 26.7271Z",
    fill: "#F56565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucideLogo);
export default __webpack_public_path__ + "static/media/lucide-logo.95a9daa9485fb72351c7ff38599b472c.svg";
export { ForwardRef as ReactComponent };